import { render } from "./customers-list.vue?vue&type=template&id=d08b7264"
import script from "./customers-list.vue?vue&type=script&lang=js"
export * from "./customers-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__